import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ModelTableOptionSelected } from 'src/app/shared/models/models';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { AuditLogComponent } from 'src/app/shared/audit-log/audit-log/audit-log.component';

@Component({
  selector: 'app-routing-setup',
  templateUrl: './routing-setup.component.html',
  styleUrls: ['./routing-setup.component.scss']
})
export class RoutingSetupComponent implements OnInit {

  public _mFormGroup: FormGroup;
  public mCity = new FormControl('', Validators.required);

  searchData: any = '';
  _mColumns: any = [];
  _mData: any = [];
  _mSitesData: any;
  editFlag: boolean = false;
  cities: any;
  sites: any = [];
  _mDataRaw: any = [];
  tableData: any;
  routingSetupData: any;
  @Input() cityName: any;
  subcribeEdit: boolean = false;
  auditFlag: boolean = false;

  constructor(private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private readonly localStorage: ServiceLocalStorage,
    public readonly dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService
  ) {
  }

  ngOnInit(): void {
    this._mFormGroup = this.fb.group({
      'city': this.mCity
    });
    this.loadCities();
  }

  loadCities() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + this.localStorage.getCompanyId(), success => {
      this.cities = success.body;
      this.mCity.setValue(success.body[0].locationId);
      if (this.mCity.value) {
        this.getAll();
      }
    }, (error) => {
    });
  }

  getAll() {
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getAllRoutingConfigBylocationIdv3}${this.mCity.value}`,
      (success) => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          this._mDataRaw = success.body;
          this._mColumns = [
            { label: 'Site', key: 'siteName' },
            { label: 'Priority optimization', key: 'priorityOptimization' },
            { label: 'Acceptable diversion', key: 'acceptableDiversion' },
            { label: ' Allow TripGeneration', key: 'allowTripGeneration' },
            { label: 'Transport SLA', key: 'transportSLA' },
            { label: 'Routing type', key: 'routingType' },
            { label: 'Status', key: 'status' }
          ];
          this.subcribeEdit = true;
          this.auditFlag = true;
          this._mData = this.setDataLocally(this._mDataRaw);
          this.tableData = this._mData;
          this.setLocalHeaders();
        } else {
          this.tableData = [];
          this._mData = [];
          this._mColumns = [];
          this._mDataRaw = [];
          this.subcribeEdit = false;
          this.auditFlag = false;
          this.notifyService.showInfo("No data found", null);
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError(error.message, null);
      }
    );
  }

  setDataLocally(data) {
    return data.map(routingConfig => ({
      id: routingConfig.id,
      siteId: routingConfig.site.siteId,
      siteName: routingConfig.site.siteName,
      priorityOptimization: routingConfig.priorityOptimization,
      acceptableDiversion: routingConfig.acceptableDiversion,
      allowTripGeneration: routingConfig.allowTripGeneration,
      transportSLA: routingConfig.transportSLA,
      routingType: routingConfig.routingType,
      status: routingConfig.status
    }));
  }

  setLocalHeaders() {
    this._mColumns.forEach((obj) => {
      (obj.key == 'site.siteName') ? obj.key = 'siteName' : null;
    });
  }

  onAddNew() {
    this.routingSetupData = '';
    this.editFlag = true;
  }

  onStatusChanged(data) {
    let msg = "WARNING : Are you sure you want to Disable this Routing Setup?";
    let msgKey = AppConstants.DEACTIVATE_MSG;
    if (data.option.status == AppConstants.DEACTIVE_STATUS) {
      msg = "WARNING : Are you sure you want to Enable Routing Setup?";
      msgKey = AppConstants.ACTIVATE_MSG;
    }
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });
    swalWithBootstrapButtons.fire({
      title: msg,
      text: msgKey,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a',
    }).then(result => {
      if (result.value) {
        swalWithBootstrapButtons.fire('Done', msgKey, 'success');
        this.onStatusToggled(data);
      } else {
        swalWithBootstrapButtons.fire('Cancelled', 'Deactivated', 'error');
        this.getAll();
      }
    });
  }

  onStatusToggled(data) {
    let status = data.option.status == AppConstants.ACTIVE_STATUS ? AppConstants.DEACTIVE_STATUS : AppConstants.ACTIVE_STATUS;
    data.option.status = status;
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(ApiConstants.enabledisableRouting + '?id=' + data.option.id + '&status=' + status, '', (success) => {
      if (success) {
        this.ngxLoader.stop();
        this.notifyService.showSuccess(success.body.message, null);
        this.getAll();
      }
    }, (error) => {
      this.ngxLoader.stop();
      console.log(error);
    });
  }

  onEditIconClicked($event: ModelTableOptionSelected) {
    if ($event.index >= 0) {
      this.editFlag = true;
      this.routingSetupData = this._mDataRaw[$event.index];
    }
  }

  getAudit(e) {
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(ApiConstants.routingSetupAudit + e.option.id, (success) => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        let data = success.body;
        let object = Object.entries(e.option);
        data.data.push(object[2]);
        this.dialog.open(AuditLogComponent, {
          autoFocus: false,
          maxHeight: '80vh',
          data: data,
          disableClose: true
        });
      } else {
        this.notifyService.showWarning("No audit logs found", null);
      }
    }, (error) => {
      this.ngxLoader.stop();
      this.notifyService.showWarning("No audit logs found.", null);
    });
  }

  onSearchKey(searchKey) {
    if (searchKey) {
      this._mData = this.tableData.filter(data => data.siteName.toLowerCase().includes(searchKey.toLowerCase()));
      if (this._mData.length == 0) {
        this._mColumns = [];
        this.subcribeEdit = false;
        this.auditFlag = false;
      }
    } else {
      this.getAll();
    }
  }


}



